import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { ServicePlanCategory } from 'src/features/servicePlanCategory/utils/types';
import { ServicePlanCategoryFormSchemaValues } from 'src/features/servicePlanCategory/utils/formSchema';

const RESOURCE = '/subscriptions/service-plan-category/:id/';

type MutationFnType = typeof mutationFn;

interface DTO extends ServicePlanCategoryFormSchemaValues {
    id: string;
}
const mutationFn = ({ id, ...data }: DTO): Promise<ServicePlanCategory> => {
    return axios.put(formatResourcePath(RESOURCE, { id }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateServicePlanCategory };
